/**
 * Collection load-more: show initial products, load more on click.
 * Re-inits when collection content is replaced (e.g. after facet filter).
 * Uses event delegation so grid buttons work after filter and on mobile/resize.
 */
(function () {
  var INITIAL_PRODUCTS = 50;
  var PRODUCTS_PER_LOAD = 25;
  var STORAGE_KEY = 'collection_grid_cols';
  var STORAGE_KEY_MOBILE = 'collection_grid_cols_mobile';

  function getSectionEl(fromSectionId) {
    if (fromSectionId) {
      var el = document.getElementById('shopify-section-' + fromSectionId);
      if (el) return el;
    }
    var grid = document.getElementById('product-grid');
    return grid ? grid.closest('[id^="shopify-section-"]') : null;
  }

  function setGridClass(sectionEl, cols) {
    if (!sectionEl) return;
    sectionEl.classList.remove('collection--grid-3', 'collection--grid-4', 'collection--grid-5', 'collection--grid-6', 'active_cards');
    sectionEl.classList.add('collection--grid-' + cols);
    if (cols === 6) sectionEl.classList.add('active_cards');
    try {
      localStorage.setItem(STORAGE_KEY, String(cols));
      if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 999px)').matches) {
        localStorage.setItem(STORAGE_KEY_MOBILE, String(cols));
      }
    } catch (e) {}
  }

  function updateProgressForSection(sectionEl) {
    if (!sectionEl) return;
    var grid = sectionEl.querySelector('#product-grid');
    if (!grid) return;
    var productCards = Array.from(grid.querySelectorAll('.product-card'));
    var toolbar = sectionEl.querySelector('.collection__grid-toolbar');
    var totalProducts = toolbar ? parseInt(toolbar.getAttribute('data-total-products') || '0', 10) : 0;
    var total = totalProducts > 0 ? totalProducts : productCards.length;
    var visibleCount = productCards.filter(function (c) { return c.classList.contains('visible'); }).length;
    var displayCount = Math.min(visibleCount, total);
    var totalForProgress = total > 0 ? total : 1;
    var pct = Math.round((displayCount / totalForProgress) * 100);
    var loadMoreStatus = sectionEl.querySelector('#load-more-status');
    var progressBar = sectionEl.querySelector('#load-more-progress-bar');
    var loadMoreBtn = sectionEl.querySelector('#load-more-btn');
    var loadMoreWrapper = sectionEl.querySelector('#collection-load-more-wrapper');
    if (loadMoreStatus) loadMoreStatus.textContent = 'Viewing 1 - ' + displayCount + ' out of ' + total + ' products';
    if (progressBar) progressBar.style.width = pct + '%';
    if (progressBar) progressBar.setAttribute('aria-valuenow', displayCount);
    if (loadMoreBtn) loadMoreBtn.style.display = visibleCount >= productCards.length ? 'none' : '';
    if (loadMoreWrapper && total > 0) loadMoreWrapper.style.display = 'flex';
  }

  function showMoreCardsForSection(sectionEl) {
    if (!sectionEl) return;
    var grid = sectionEl.querySelector('#product-grid');
    if (!grid) return;
    var productCards = Array.from(grid.querySelectorAll('.product-card'));
    var visibleCount = productCards.filter(function (c) { return c.classList.contains('visible'); }).length;
    var newCount = Math.min(visibleCount + PRODUCTS_PER_LOAD, productCards.length);
    productCards.forEach(function (card, i) {
      if (i < newCount) card.classList.add('visible');
      else card.classList.remove('visible');
    });
    updateProgressForSection(sectionEl);
  }

  function init(sectionId) {
    var sectionEl = getSectionEl(sectionId);
    if (!sectionEl) return;

    var grid = sectionEl.querySelector('#product-grid');
    if (!grid) return;

    var productCards = Array.from(grid.querySelectorAll('.product-card'));
    if (productCards.length === 0) return;

    var toolbar = sectionEl.querySelector('.collection__grid-toolbar');
    var isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 999px)').matches;
    var savedCols = 4;
    try {
      savedCols = parseInt(isMobile ? (localStorage.getItem(STORAGE_KEY_MOBILE) || '4') : (localStorage.getItem(STORAGE_KEY) || '4'), 10);
    } catch (e) {}
    if (!isMobile && savedCols === 3) savedCols = 4;
    if (savedCols >= 3 && savedCols <= 6) {
      setGridClass(sectionEl, savedCols);
      var btns = sectionEl.querySelectorAll('.collection__grid-view-btns button');
      if (btns.length) {
        btns.forEach(function (btn) {
          var c = parseInt(btn.getAttribute('data-cols'), 10);
          if (c === savedCols) {
            btn.classList.add('is-active');
            btn.setAttribute('aria-pressed', 'true');
          } else {
            btn.classList.remove('is-active');
            btn.setAttribute('aria-pressed', 'false');
          }
        });
      }
    }

    var initialCount = Math.min(INITIAL_PRODUCTS, productCards.length);
    productCards.forEach(function (card, i) {
      if (i < initialCount) card.classList.add('visible');
      else card.classList.remove('visible');
    });
    grid.setAttribute('data-load-more-initialized', 'true');
    updateProgressForSection(sectionEl);
  }

  function onGridButtonClick(btn) {
    var sectionEl = btn.closest('[id^="shopify-section-"]');
    if (!sectionEl) return;
    var cols = parseInt(btn.getAttribute('data-cols'), 10);
    if (isNaN(cols) || cols < 3 || cols > 6) return;
    setGridClass(sectionEl, cols);
    /* Update all grid toolbars in section (desktop + mobile) so active state stays in sync */
    sectionEl.querySelectorAll('.collection__grid-toolbar').forEach(function (toolbar) {
      toolbar.querySelectorAll('.collection__grid-view-btns button').forEach(function (b) {
        var c = parseInt(b.getAttribute('data-cols'), 10);
        b.classList.toggle('is-active', c === cols);
        b.setAttribute('aria-pressed', c === cols ? 'true' : 'false');
      });
    });
    updateProgressForSection(sectionEl);
  }

  document.addEventListener('click', function (e) {
    var gridBtn = e.target.closest('.collection__grid-view-btns button[data-cols]');
    if (gridBtn) {
      e.preventDefault();
      onGridButtonClick(gridBtn);
      return;
    }
    var loadMoreBtn = e.target.closest('#load-more-btn');
    if (loadMoreBtn) {
      e.preventDefault();
      var sectionEl = loadMoreBtn.closest('[id^="shopify-section-"]');
      showMoreCardsForSection(sectionEl);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('facet:content-replaced', function (e) {
    var sectionId = e.detail && e.detail.sectionId;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        init(sectionId);
      });
    });
  });
})();
